"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FormCheckBoxGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormCheckBoxGroup, _PureComponent);
  var _super = _createSuper(FormCheckBoxGroup);
  function FormCheckBoxGroup() {
    _classCallCheck(this, FormCheckBoxGroup);
    return _super.apply(this, arguments);
  }
  _createClass(FormCheckBoxGroup, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        checkBoxClassName = _this$props.checkBoxClassName,
        checkBoxFieldStyle = _this$props.checkBoxFieldStyle,
        checkBoxLabelPosition = _this$props.checkBoxLabelPosition,
        className = _this$props.className,
        disabled = _this$props.disabled,
        error = _this$props.error,
        hint = _this$props.hint,
        id = _this$props.id,
        label = _this$props.label,
        labelClassName = _this$props.labelClassName,
        labelKey = _this$props.labelKey,
        options = _this$props.options,
        style = _this$props.style,
        valueKey = _this$props.valueKey;
      var fields = (0, _lodash.reduce)(options, function (acc, option) {
        return [].concat(_toConsumableArray(acc), [(0, _lodash.get)(_this.props, option[valueKey])]);
      }, []);
      var isTouched = (0, _lodash.some)(fields, function (field) {
        return (0, _lodash.get)(field, 'meta.touched', false);
      });
      var checkboxGroupContainerClass = function checkboxGroupContainerClass() {
        return (0, _classnames["default"])({
          'ui-form-checkbox-group': true,
          'ui-form-field': true,
          'ui-form-field--has-error': !(0, _lodash.isEmpty)(error) && isTouched
        }, className);
      };
      var labelClass = function labelClass() {
        return (0, _classnames["default"])({
          'ui-form-field__label': true
        }, labelClassName);
      };
      var checkboxes = options.map(function (opt, index) {
        var value = (0, _lodash.get)(opt, valueKey, '');
        var field = (0, _lodash.get)(_this.props, value);
        return /*#__PURE__*/_react["default"].createElement(_ui.CheckBoxField, _extends({
          key: "checkbox-".concat(id, "-").concat(value),
          id: "".concat(id, "-checkbox-").concat(index),
          className: checkBoxClassName,
          labelPosition: checkBoxLabelPosition,
          disabled: disabled || (0, _lodash.get)(opt, 'disabled', false),
          name: value,
          label: (0, _lodash.get)(opt, labelKey, ''),
          style: checkBoxFieldStyle
        }, field));
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: id,
        className: checkboxGroupContainerClass()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: labelClass()
      }, label), checkboxes, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-field__error",
        style: style.error
      }, isTouched && error), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-field__hint",
        style: style.hint
      }, hint));
    }
  }]);
  return FormCheckBoxGroup;
}(_react.PureComponent);
FormCheckBoxGroup.propTypes = {
  /** className for checkbox */
  checkBoxClassName: _propTypes["default"].string,
  /** Override the inline-styles of the elements || **Not Recommended** */
  checkBoxFieldStyle: _propTypes["default"].shape({
    container: _propTypes["default"].object,
    error: _propTypes["default"].object,
    hint: _propTypes["default"].object,
    input: _propTypes["default"].object,
    label: _propTypes["default"].object
  }),
  /** Position of the checkbox label */
  checkBoxLabelPosition: _propTypes["default"].oneOf(['right', 'left']),
  /** className for reference, defaults to empty string */
  className: _propTypes["default"].string,
  /** Bool used to determine if FormCheckBoxGroup is disabled as a whole */
  disabled: _propTypes["default"].bool,
  /** Potential error message */
  error: _propTypes["default"].string,
  /** Help text displayed below the input */
  hint: _propTypes["default"].string,
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** label text for checkbox group */
  label: _propTypes["default"].string.isRequired,
  /** className for label, defaults to empty string */
  labelClassName: _propTypes["default"].string,
  /** Key used for the label */
  labelKey: _propTypes["default"].string,
  /** checkbox options */
  options: _propTypes["default"].array,
  /** Override the inline-styles of the elements || **Not Recommended** */
  style: _propTypes["default"].shape({
    container: _propTypes["default"].object,
    label: _propTypes["default"].object,
    hint: _propTypes["default"].object,
    error: _propTypes["default"].object
  }),
  /** Key used for the value */
  valueKey: _propTypes["default"].string
};
FormCheckBoxGroup.defaultProps = {
  checkBoxClassName: '',
  checkBoxFieldStyle: {
    container: {},
    error: {},
    hint: {},
    input: {},
    label: {}
  },
  checkBoxLabelPosition: 'right',
  className: '',
  disabled: false,
  error: '',
  hint: '',
  labelClassName: '',
  labelKey: 'label',
  labelPosition: 'right',
  options: [],
  style: {
    container: {},
    label: {},
    hint: {},
    error: {}
  },
  valueKey: 'value'
};
var _default = exports["default"] = FormCheckBoxGroup;